<script setup lang="ts">
  import { CDN_URL } from '@/shared/constants'

  interface Props {
    discountPrice: number | string
  }

  defineProps<Props>()

  const COIN_ICON_URL = `${CDN_URL}/qatar/loyalty/images/coin_icon.svg`
</script>

<template>
  <p class="coins-discount-info">
    <span class="coins-discount-info__text">{{
      $t('select_plan.price_with_coins', { price: discountPrice })
    }}</span>
    <img :src="COIN_ICON_URL" alt="" class="coins-discount-info__coin" />
  </p>
</template>

<style scoped lang="scss">
  @use '@/shared/assets/styles/utils' as *;
  @use '@qicgroupdoha/qic-connect-ds/scss/typography';

  .coins-discount-info {
    margin-block-end: var(--spacing-2-5);
    display: flex;
    gap: var(--spacing-2);
    align-items: center;

    &__text {
      @include typography.text-medium;

      color: var(--colorTxtSrfAction);
      background: linear-gradient(269.71deg, #ffb0b5 0.25%, #df7be8 37.94%, #6f72ed 80.17%);
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
</style>
